module.exports = "/images/avatar-s-16.jpg?14093ce92facf62dd7ae31123483b4f6";